import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const { checkAuth } = useAuth();
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Lien de vérification invalide');
      return;
    }

    const verify = async () => {
      try {
        const res = await axios.get(`${API}/auth/verify-email?token=${token}`);
        setStatus('success');
        setMessage(res.data.message);
        // Refresh user data to update email_verified status
        await checkAuth();
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Erreur lors de la vérification');
      }
    };

    verify();
  }, [token, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="verify-email-page">
      <div className="w-full max-w-md text-center">
        <div className="bg-[#121212] rounded-2xl p-10 border border-white/10">
          {status === 'loading' && (
            <>
              <Loader2 className="w-16 h-16 text-fuchsia-500 animate-spin mx-auto mb-6" />
              <h2 className="text-2xl font-bold text-white font-outfit mb-3">Vérification en cours...</h2>
              <p className="text-gray-400">Veuillez patienter</p>
            </>
          )}

          {status === 'success' && (
            <>
              <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-6" />
              <h2 className="text-2xl font-bold text-white font-outfit mb-3">Email vérifié !</h2>
              <p className="text-gray-400 mb-8">{message}</p>
              <Link to="/shop">
                <Button className="bg-fuchsia-600 hover:bg-fuchsia-500 text-white px-8 py-6" data-testid="go-to-shop-btn">
                  Explorer la boutique
                </Button>
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <XCircle className="w-16 h-16 text-red-500 mx-auto mb-6" />
              <h2 className="text-2xl font-bold text-white font-outfit mb-3">Erreur de vérification</h2>
              <p className="text-gray-400 mb-8">{message}</p>
              <Link to="/shop">
                <Button className="bg-fuchsia-600 hover:bg-fuchsia-500 text-white px-8 py-6" data-testid="go-to-shop-btn">
                  Retour à la boutique
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
